export const ApiKey = process.env.REACT_APP_FIREBASE_API_KEY
export const AuthDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
export const ProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID
export const StorageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
export const MessagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
export const AppId = process.env.REACT_APP_FIREBASE_APP_ID
export const MeasurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
export const keyEncrypt = process.env.REACT_APP_ENCRYPT